import { CircularProgressBar } from '@openhouse-engineers/rrc'
import { isNil } from 'lodash'
import React from 'react'

import Text from 'components/common/Text'

import { ProgressBar } from './styles'

import { Row, Content } from '../../styles'

const getCopy = ({ isTeacher, percentage }) => {
    const copy = {
        title: '',
        subtitle: '',
    }

    if (isTeacher) {
        if (percentage < 30) {
            copy.title = 'Oh! Is everything okay?'
            copy.subtitle = 'Do interact with your class more.'
        } else if (percentage > 30 && percentage < 60) {
            copy.title = 'Good going!'
            copy.subtitle = "You're having an interactive class today."
        } else {
            copy.title = "Woah! It's great that you have so much to say."
            copy.subtitle =
                'But, we advise you to get students to interact with each other.'
        }
    } else {
        if (percentage < 30) {
            copy.title = 'Why have you been so quiet?'
            copy.subtitle =
                'Interacting in class is not as bad as you think. Speak up!'
        } else if (percentage > 30 && percentage < 60) {
            copy.title = 'Someone is on a roll today!'
            copy.subtitle = "Isn't it fun to be interacting in your class?"
        } else {
            copy.title = "Woah! It's great that you have so much to say."
            copy.subtitle = 'Time to nudge your peers to start interacting!'
        }
    }

    return copy
}

const ProgressWithCopy = ({ color, isTeacher, percentage, rowReverse }) => {
    if (isNil(percentage)) return null

    const text = `${percentage}%`
    const copy = getCopy({ isTeacher, percentage })

    return (
        <Row border rowReverse={rowReverse}>
            <Content>
                <Text level="3" bold={false}>
                    {copy.title}
                </Text>
                <Text level="2" bold={false} color="#ffffff8f">
                    {copy.subtitle}
                </Text>
            </Content>
            <ProgressBar rowReverse={rowReverse}>
                <CircularProgressBar
                    percentage={percentage}
                    bgStrokeColor="#000000"
                    progressStrokeColor={color}
                    text={text}
                />
            </ProgressBar>
        </Row>
    )
}

export default ProgressWithCopy
